import classNames from 'classnames/bind';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';
import Select from '@/components/ui/kit/Select';
import { roundToDecimal } from '@/utils/Formatter';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const [mode, setMode] = useState();
  const domRefs = useRef({
    altitude: useRef(),
  }).current;

  useEffect(() => {
    domRefs.altitude.current.value = command.data.altitude.toFixed(1);
    setMode(command.data.mode);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(e.target.value);

    // Relative Altitude 변경된 경우
    if (name === 'altitude') {
      const nextValue = roundToDecimal(value);
      dispatch(actions.mission.updateCommand(index, name, nextValue));
    }
    // Mode 변경된 경우
    else if (name === 'mode') {
      dispatch(actions.mission.updateCommand(index, name, value));
    }
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Relative Altitude" unit="m">
        <FieldNumber ref={domRefs.altitude} name="altitude" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Mode">
        <Select name="mode" value={mode} onChange={handleBlur} className={cx('select')}>
          <option value={0}>Neutral</option>
          <option value={1}>Climb</option>
          <option value={2}>Descend</option>
        </Select>
      </FieldRow>
    </div>
  );
};

export default Command;
